<template>
  <aside class="store-links">
    <img class="store-links__illustration" src="@/assets/images/illustration.svg" alt="Illustration" />
    <section class="store-links__app-buttons">
      <a class="store-links__app-button store-links__app-button--disabled store-links__app-button--play" href="#">
        <icon-google-play class="ico" />
        <span class="store-links__app-button__content">
          <span class="small">Get it on</span>
          Google play
        </span>
      </a>
      <a class="store-links__app-button store-links__app-button--disabled store-links__app-button--store" href="#">
        <icon-app-store class="ico" />
        <span class="store-links__app-button__content">
          <span class="small">Coming soon to the</span>
          App store
        </span>
      </a>
    </section>
  </aside>
</template>

<script>
  import IconGooglePlay from './content-icons/icon-google-play.vue';
  import IconAppStore from './content-icons/icon-app-store.vue';

  export default {
    name: 'StoreLinks',
    components: {
      IconGooglePlay,
      IconAppStore
    }
  };
</script>

<style lang="scss">
  @import 'src/scss/variables';

  .store-links {
    background-color: $light-blue;
    width: 39%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 50px 25px;
    min-height: 100vh;

    @media screen and (max-width: 990px) {
      width: 100%;
    }

    &__illustration {
      max-width: 100%;
      height: auto;
    }

    &__app-buttons {
      display: flex;
      margin: 96px -12px -10px;

      @media (max-width: 1700px) and (min-width: 990px) {
        flex-direction: column;
      }

      @media (max-width: 768px) {
        margin-top: 50px;
        flex-direction: column;
      }
    }

    &__app-button {
      font-size: 2.1rem;
      font-weight: 600;
      min-width: 260px;
      color: $white;
      border-radius: 8px;
      background-image: linear-gradient(104deg, $gradient-1, $gradient-2);
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      padding: 15px 37px 15px 38px;
      text-transform: capitalize;
      position: relative;
      line-height: 1.05;
      margin: 10px 12px;

      &__content {
        display: flex;
        flex-direction: column;

        .small {
          font-size: 1.2rem;
          font-weight: 500;
          text-transform: uppercase;
        }
      }

      .ico {
        margin-right: 33px;
      }

      &--disabled {
        pointer-events: none;
        background: $gray;

        .small {
          text-transform: none;
        }
      }
    }
  }
</style>
